import embla from 'embla-carousel';
import autoplay from 'embla-carousel-autoplay';

class ProductsBanner {
  constructor() {
    const sections = document.querySelectorAll('.products-banner');

    sections.forEach(section => {
      const root = section.querySelector('.products-banner__slider');
      const prev = section.querySelector('.products-banner__button--prev');
      const next = section.querySelector('.products-banner__button--next');
      const items = section.querySelectorAll('.products-banner-item');

      const options = {
        loop: true,
        watchDrag: items.length > 1 ? true : false,
      };

      const plugins = [
        autoplay({
          delay: 5000,
          stopOnMouseEnter: true,
        })
      ];

      const carousel = embla(root, options, plugins);

      prev?.addEventListener('click', carousel.scrollPrev);
      next?.addEventListener('click', carousel.scrollNext);
    });
  }
}

export default ProductsBanner;
